export default "__VITE_ASSET__5pIz38RP__"